import {  Link } from "react-router";
import React, { useState } from 'react';

function AddDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle dropdown state
  const AddDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="add-project">
      {/* Toggle button */}
      <span onClick={AddDropdown}></span>

      {/* Dropdown content */}
      {isOpen && (
        <ul className="dd-style">
          <li><Link to={"/add-store"}>Store</Link></li>
		  <li><Link to={"/add-product"}>Product</Link></li>
        </ul>
      )}
    </div>
  );
}

export default AddDropdown;
